
export default {
	data() {
		return {
			qrUrl: 'https://oss.pzds.com/imgv2/2024121702wx-public.jpg'
		}
	}
}
